import { CollapsablePanel } from '@app/app/_components/CollapsablePanel/CollapsablePanel';
import { RadioButtonInput } from '@app/app/_components/Input/RadioButtonInput';
import { ReadOnlyField } from '@app/app/_components/ReadOnlyField/ReadOnlyField';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';

interface Props {
    totalPrice: number;
    priceToPayNow: number;
    paymentFrequency: number;
    onPaymentFrequencyChange: (paymentFrequency: number) => void;
}

export function PaymentFrequencyPanel({
    totalPrice,
    priceToPayNow,
    paymentFrequency,
    onPaymentFrequencyChange,
}: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();

    const [localPaymentFrequency, setLocalPaymentFrequency] = useState(paymentFrequency);

    const paymentCountOptions = [
        {
            value: '1',
            label: t('eshop.general.singlePayment'),
        },
        {
            value: '2',
            label: t('eshop.general.twoPayments'),
        },
        {
            value: '4',
            label: t('eshop.general.fourPayments'),
        },
        {
            value: '6',
            label: t('eshop.general.sixPayments'),
        },
        {
            value: '12',
            label: t('eshop.general.TwelvePayments'),
        },
    ];

    const handlePaymentFrequencyChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const newPaymentFrequency = parseInt(e.target.value);
            setLocalPaymentFrequency(newPaymentFrequency);
            onPaymentFrequencyChange(newPaymentFrequency);
        },
        [onPaymentFrequencyChange],
    );

    return (
        <CollapsablePanel label={t('eshop.home.summary.paymentFrequencyPerYear')} collapsable={false}>
            <div className="flex flex-col gap-6 px-6 py-2">
                <RadioButtonInput
                    name="paymentCount"
                    onChange={handlePaymentFrequencyChange}
                    label={t('eshop.general.numberOfPaymentsLabel')}
                    defaultValue={localPaymentFrequency.toString()}
                    choices={paymentCountOptions}
                />

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <ReadOnlyField label={t('eshop.home.summary.totalToPayNowLabel')}>
                        {formatEuroValue(priceToPayNow, tenant)}
                    </ReadOnlyField>
                    <ReadOnlyField label={t('eshop.home.summary.totalForTwelveMonthsLabel')}>
                        {formatEuroValue(totalPrice, tenant)}
                    </ReadOnlyField>
                </div>
            </div>
        </CollapsablePanel>
    );
}
